import React from 'react'
import { Badge, Box, Text, Flex, Button } from '@chakra-ui/react'
import {
    ActionItemFieldsFragment,
    PrescriptionRefillRequestType,
} from '~graphql/generated/graphql'
import { formatHumanReadableDate } from '~components/chats/chat/messages-list/message-content/message-helpers'
import { navigate } from 'gatsby'
import { UserRoutes } from '~config/routes'
import RefillRequestActions from '~components/booking/prescription-refill-requests/actions/refill-request-actions'

export default function PrescriptionContent({
    actionItem,
}: {
    actionItem: ActionItemFieldsFragment
}) {
    const refillRequest = actionItem.prescription_refill_request

    if (!refillRequest) return <></>

    const prescriptionName =
        refillRequest.prescription?.product?.name ||
        refillRequest.prescription?.product_name ||
        refillRequest.prescription?.name ||
        'Prescription'

    async function handleViewMore() {
        navigate(UserRoutes.PendingActions)
    }

    return (
        <>
            <Box w="full">
                <Flex
                    mt={1}
                    justify="space-between"
                    alignItems="center"
                    direction="row"
                    gap={3}
                >
                    <Box>
                        <Flex alignItems="center" gap={2}>
                            <Text fontWeight="semibold">
                                Prescription{' '}
                                {refillRequest.type ===
                                PrescriptionRefillRequestType.Renewal
                                    ? 'renewal'
                                    : 'refill'}{' '}
                                requested for {refillRequest.patient?.name}
                            </Text>
                            <Badge
                                colorScheme={
                                    refillRequest.type ===
                                    PrescriptionRefillRequestType.Renewal
                                        ? 'purple'
                                        : 'blue'
                                }
                                variant="subtle"
                                rounded="full"
                                fontSize="2xs"
                                px={2}
                            >
                                {refillRequest.type}
                            </Badge>
                        </Flex>
                        <Text fontSize="sm" color="gray.600" noOfLines={1}>
                            {prescriptionName} — Requested{' '}
                            {formatHumanReadableDate(
                                actionItem.created_at || 0,
                            )}
                        </Text>
                    </Box>
                    <Flex gap={2} flexDirection="column" w="max-content">
                        <Button
                            size="xs"
                            shadow="sm"
                            colorScheme="gray"
                            onClick={handleViewMore}
                        >
                            View details
                        </Button>
                        <RefillRequestActions
                            refillRequest={refillRequest}
                            buttonOverrides={{ size: 'xs' }}
                        />
                    </Flex>
                </Flex>
            </Box>
        </>
    )
}
